/**
 * Backend (BFF) host — set per environment in .env / .env.<mode>
 * (see root CLAUDE.md → "Deployment — per-environment .env files").
 */
export const AZURE_BASE_URL = import.meta.env.VITE_AZURE_API_BASE_URL;

/** The BFF's `/api` route prefix — used as the axios `baseURL`. */
export const AZURE_API_BASE_URL = `${AZURE_BASE_URL}/api`;
